document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
      e.preventDefault();

      const targetId = this.getAttribute('href');
      const targetSection = document.querySelector(targetId);

      if (targetSection) {
          targetSection.scrollIntoView({
              behavior: 'smooth'
          });
      }
  });
});

if (window.innerWidth >= 768) {
    document.addEventListener('scroll', function() {
        var secondDiv = document.querySelector('.anchor-links');
        var nav = document.getElementById('anchor-nav');
        var navHeight = nav.offsetHeight;
        
        if (window.scrollY >= secondDiv.offsetTop - navHeight) {
          nav.style.display = 'block';
          nav.style.zIndex = 9999;
          nav.style.position = 'fixed';
          nav.style.padding = '20px 50px';
        } else {
          nav.style.display = 'block';
          nav.style.position = '';
        }
      });
    
      $(document).ready(function() {
        $(window).scroll(function() {
          var scrollThreshold = 50;
          
          $('.scroll-section').each(function() {
            var targetOffset = $(this).offset().top;
            var windowOffset = $(window).scrollTop();
            var windowHeight = $(window).height();
      
            // Check if the user has scrolled to the current section
            if (windowOffset + windowHeight > targetOffset + scrollThreshold) {
              var currentSectionId = $(this).attr('id');
              
              // Remove 'current' class from all navigation items
              $('nav ul li a').removeClass('current');
              
              // Add 'current' class to the corresponding navigation item
              $('nav ul li a[href="#' + currentSectionId + '"]').addClass('current');
            }
          });
        });
      });
  } else {
    var secondDiv = document.querySelector('.anchor-links');
    var nav = document.getElementById('anchor-nav');
    nav.style.display = 'none';
  }